import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../../services/auth/auth';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(Auth);
  const router = inject(Router);

  // Wait for Clerk to finish loading if it hasn't yet
  if (!authService.isLoaded()) {
    await new Promise<void>((resolve) => {
      const check = setInterval(() => {
        if (authService.isLoaded()) {
          clearInterval(check);
          resolve();
        }
      }, 50);
    });
  }

  if (authService.isSignedIn()) {
    return true;
  }

  // Redirect unauthenticated users to landing page
  return router.createUrlTree(['/']);
};
